import {
  Card,
  CardContent,
  Grid,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";
import { BIBlue } from "../../assets/helpers";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function DashboardCard({ title, count, onClick, color = BIBlue, subtitle }) {
  const { multiLanguageData, } = useSelector((state) => state?.main);

  const LANGUAGE = ClientEnglishFallback.ClientHome(multiLanguageData?.ClientHome || {});

  const { TEXT_PENDING_APPROVAL } = LANGUAGE;

  return (
    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
      <Card
        style={{
          borderRadius: "10px",
          cursor: "pointer",
          height: "100%",
          boxShadow: "none"
        }}
        onClick={onClick}>
        <CardContent
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            rowGap: "20px"
          }}>
          <Typography variant="h5" fontWeight="300" fontSize="large">
            {title}
          </Typography>
          <Typography fontWeight="500" fontSize="30px" sx={{ color: color }}>
            {count}
          </Typography>
          <Typography variant="h5" fontWeight="300" fontSize="large">
            {subtitle || TEXT_PENDING_APPROVAL}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default DashboardCard;
